import {
  SET_FORECAST_CASH_TO_EARNING_DATA,
  SET_FORECAST_CASH_TO_EARNING
} from "./mutations";
import {store} from "../../index";
import ForecastCashToEarnings, {
  PreTaxNetIncomeConversionFactor,
  CashToEarningsFactor
} from "../../../models/valuation/ForecastCashToEarnings";
import {generateForecastFreeCashFlow} from "../forecastFCF/actions";
import {generateCapitalizationRate} from "../capitalizationRate/actions";

export const setForecastCashToEarningData = (payload) => ({
  type: SET_FORECAST_CASH_TO_EARNING_DATA,
  payload,
});

export const generateForecastCashToEarnings = (options = { clearCache: false }) => (dispatch) => {
  //dispatch(generateForecastFreeCashFlow())
  dispatch(generateCapitalizationRate())

  const { forecastCashToEarnings, forecastFCF, capitalizationRate } = store.getState()

  if (forecastCashToEarnings?.forecastCashToEarnings && !options.clearCache) {
    const _forecastCashToEarnings = new ForecastCashToEarnings({
      preTaxNetIncomeConversionFactor: new PreTaxNetIncomeConversionFactor({
        ...forecastCashToEarnings?.forecastCashToEarnings?.preTaxNetIncomeConversionFactor,
        preTaxFreeCashFlow: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowBeforeTax.preTaxFreeCashFlow,
        ebit: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.ebit,
      }),
      cashToEarningsFactor: new CashToEarningsFactor({
        ...forecastCashToEarnings?.forecastCashToEarnings?.cashToEarningsFactor,
        preTaxNetCashFlowCapitalizationRate: capitalizationRate.capitalizationRate.preTaxCapitalizationRate.preTaxNetCashFlowCapitalizationRate
      })
    })

    _forecastCashToEarnings.cashToEarningsFactor.predictedFactor = _forecastCashToEarnings.preTaxNetIncomeConversionFactor.predictedFactor

    dispatch({
      type: SET_FORECAST_CASH_TO_EARNING,
      payload: _forecastCashToEarnings
    })

    return
  }

  const _forecastCashToEarnings = new ForecastCashToEarnings({
    preTaxNetIncomeConversionFactor: new PreTaxNetIncomeConversionFactor({
      preTaxFreeCashFlow: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowBeforeTax.preTaxFreeCashFlow,
      ebit: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.ebit
    }),
    cashToEarningsFactor: new CashToEarningsFactor({
      preTaxNetCashFlowCapitalizationRate: capitalizationRate.capitalizationRate.preTaxCapitalizationRate.preTaxNetCashFlowCapitalizationRate
    })
  })

  _forecastCashToEarnings.cashToEarningsFactor.predictedFactor = _forecastCashToEarnings.preTaxNetIncomeConversionFactor.predictedFactor


  dispatch({
    type: SET_FORECAST_CASH_TO_EARNING,
    payload: _forecastCashToEarnings
  })
}
